import MessagingTourFakeApi from './fake/MessagingTourFakeApi';

export default class FakeApi {
    static MessagingTour = MessagingTourFakeApi;
}
